import { render, staticRenderFns } from "./answerEdit.vue?vue&type=template&id=2bf3caec&scoped=true"
import script from "./answerEdit.vue?vue&type=script&lang=js"
export * from "./answerEdit.vue?vue&type=script&lang=js"
import style0 from "./answerEdit.vue?vue&type=style&index=0&id=2bf3caec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf3caec",
  null
  
)

export default component.exports